module.exports = __webpack_public_path__ + "static/gallery-13@2x-151dcbea60dd50a5287f7fc940978d4a.jpg";